/* Edward Teach — Theme JS */

// ── TOAST NOTIFICATION ──
function showToast(message) {
  var toast = document.getElementById('cart-toast');
  var msg = document.getElementById('cart-toast-msg');
  if (!toast) return;
  msg.textContent = message;
  toast.classList.add('show');
  setTimeout(function() { toast.classList.remove('show'); }, 2800);
}

// ── UPDATE CART COUNT ──
function refreshCartCount() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      document.querySelectorAll('.cart-count').forEach(function(el) {
        el.textContent = cart.item_count;
      });
    });
}

// ── AJAX ADD TO CART (quick-add forms) ──
document.addEventListener('DOMContentLoaded', function() {

  // Intercept quick-add forms on collection/grid pages
  document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      // Only intercept if not handled by inline onclick
      if (form.dataset.ajax === 'false') return;
      e.preventDefault();
      var id = form.querySelector('[name="id"]').value;
      var qty = form.querySelector('[name="quantity"]') ? form.querySelector('[name="quantity"]').value : 1;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(id), quantity: parseInt(qty) })
      })
      .then(function(r) { return r.json(); })
      .then(function(item) {
        refreshCartCount();
        showToast((item.title || 'Item') + ' added to cart');
      })
      .catch(function(err) {
        console.error('Add to cart error:', err);
      });
    });
  });

  // Refresh count on page load
  refreshCartCount();
});
